import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {

    // Properties
    public loadStart: EventEmitter<string> = new EventEmitter();
    public loadEnd: EventEmitter<string> = new EventEmitter();
    public displayBigLoader: boolean = false;
    public liveRequests: number = 0;

    // Attributes
    private _liveRequests: string[] = []; 

    constructor() {
    }
    
    // Public methods
    register(requestId: string) {
        const index = this._liveRequests.indexOf(requestId);

        if (index == -1) {
            this._liveRequests.push(requestId);
            this.liveRequests++;

            if (this._liveRequests.length == 1) {
                this.loadStart.emit(requestId);
            }
        }
    }

    unregister(requestId: string) {
        const index = this._liveRequests.indexOf(requestId);

        if (index >= 0) {
            this._liveRequests.splice(index, 1);  
            this.liveRequests--; 

            if (this._liveRequests.length == 0) {
                this.loadEnd.emit("");
            }         
        }
    }

    restart() {
        this._liveRequests = [];
        this.liveRequests = 0;
        this.loadEnd.emit("");
        this.displayBigLoader = false;
    }

    start() {
        this._liveRequests = ["FORCED"];
        this.liveRequests = 1;
        this.loadStart.emit("FORCED");
        this.displayBigLoader = true;
    }

    end() {
        this._liveRequests = [];
        this.liveRequests = 0;
        this.loadEnd.emit("FORCED");
        this.displayBigLoader = false;
    }

}